import { Calendar as CalendarIcon } from 'iconoir-react'
import { useMemo } from 'react'
import Combo from 'app/components/ui/combo/combo'
import type { ScorecardJson } from 'app/types/entities'

const SelectorPresetOptions = [
  {
    value: `trailing_periods`,
    name: `Trailing Periods`,
    id: `trailing_periods`,
  },
  {
    value: `year_over_year`,
    name: `Year over Year`,
    id: `year_over_year`,
  },
]

export default function LookbackTypeSelector({
  currentDateRange,
  currentValue,
  inputClassName,
  onChange,
}: {
  currentDateRange: NonNullable<ScorecardJson[`dateRange`]>
  currentValue: string
  inputClassName?: string
  onChange: (value: string) => void
}) {
  const value = useMemo(() => SelectorPresetOptions.find((option) => option.value === currentValue), [currentValue])
  const options = useMemo(() => {
    const noYoY = [`this_year`, `last_year`, `last_30_days`, `last_90_days`]
    if (noYoY.includes(currentDateRange)) {
      return SelectorPresetOptions.filter((option) => option.value !== `year_over_year`)
    }
    return SelectorPresetOptions
  }, [currentDateRange])

  return (
    <Combo
      showSearchInDropdown={false}
      options={options}
      value={value}
      onChange={(option) => onChange(option.value)}
      customIcon={<CalendarIcon className="h-5 w-5 text-default" />}
      className="!h-fit w-48 cursor-pointer"
      optionsContainerClassName="min-w-0 w-64"
      inputClassName={inputClassName}
    />
  )
}
